<template>
  <BackgroundImage
    :background="heroImage"
    :preload="true"
    :_type="'imageBackground'"
    background-size="full-page"
    :class="{
      'bg-left-bottom pb-20 pt-120px lg:bg-top': true,
    }"
  >
    <div class="container mx-auto px-0 text-www-color-white">
      <h1 class="mb-4 text-28px font-black leading-8 lg:text-6xl lg:leading-69px">
        {{ title }}
      </h1>
      <p class="mb-30px text-lg font-normal leading-8">
        {{ subtitle }}
      </p>
      <ButtonRow
        v-if="ctaButtons"
        v-bind="ctaButtons"
      />
    </div>
  </BackgroundImage>
</template>

<script lang="ts" setup>
import BackgroundImage from '~/components/Atmos/BackgroundImage/BackgroundImage.vue';
import ButtonRow from '~/components/Atmos/ButtonRow/ButtonRow.vue';
import type { QueryEnterpriseResult } from '~/sanity/types';
type ABMProps = {
  abmHero: NonNullable<QueryEnterpriseResult>['abmHero'];
};
const props = defineProps<ABMProps>();
const { title, subtitle, heroImage, ctaButtons } = props.abmHero;
</script>
